export default __webpack_public_path__ + "settings-thank-you-page-manual-tik-em-door.svg";